<template>
    <div></div>
</template>

<script>
export default {
    name: 'DeleteUser',
    props: {
        popupDeleteUser: {
            type: Boolean,
            default: false,
        },
        userId: Number,
        name: String,
        lastName: String
    },

    watch: { 
      	popupDeleteUser: function(newVal) {
            if(newVal == true){
                this.$vs.dialog({
                    type: 'confirm',
                    color: 'danger',
                    title: "حذف کاربر",
                    text: `${this.name} ${this.lastName} حذف شود؟`,
                    acceptText: "حذف",
                    cancelText: "انصراف",
                    accept: this.deleteUser,
                    cancel: this.cancelDelete,
                })
            }            
        },
    },
    
    methods: {
        cancelDelete(){
            this.$emit('updatePopupDeleteUser', false)
        },

        deleteUser(){
            this.$vs.loading()
            this.$emit('updatePopupDeleteUser', false)
			this.$store.dispatch('deleteUser', this.userId)
			.then(() => {
				this.$vs.loading.close()
				this.$vs.notify({
					title: '',
					text: 'کاربر با موفقیت حذف شد.',
					iconPack: 'feather',
					icon: 'icon-check-square',
					color: 'success'
				})
			})
			.catch(() => {
				this.$vs.loading.close()
				this.$vs.notify({
				title: '',
				text: 'خطا در اتصال به اینترنت',
				iconPack: 'feather',
				icon: 'icon-alert-circle',
				color: 'warning'
				})
			})
		},
    }
}
</script>